<template>
  <component :is="tag || 'div'" class="strip">
    <slot />
  </component>
</template>

<script setup lang="ts">
defineProps<{
  tag?: string;
}>();
</script>

<style scoped>
.strip {
  background: linear-gradient(90deg, rgb(var(--v-theme-tertiary)), rgb(var(--v-theme-secondary)), #5A4FCF, #3DBF9E);
  background-size: 400% 100%;
  animation: move 6s ease-in-out infinite alternate;
  text-align: center;
}
:deep(*) {
  color: white;
}
@keyframes move {
  0% { background-position: 0% 50% }
  25% { background-position: 25% 50% }
  50% { background-position: 50% 50% }
  75% { background-position: 75% 50% }
  100% { background-position: 100% 50% }
}
</style>